module.exports = __webpack_public_path__ + "static/img/step-0.348e517.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/tuto-unlock-popup/firefox/step-0.png
// module id = 952
// module chunks = 0